import { render, staticRenderFns } from "./DetailCandidatureEnseignant.vue?vue&type=template&id=4b931ff4"
import script from "./DetailCandidatureEnseignant.vue?vue&type=script&lang=js"
export * from "./DetailCandidatureEnseignant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports